<template>
    <div class="page">
        <div class="item" v-for="(item, index) in list" :key="index">
            <h2>{{index+1}}. {{item.title}}</h2>
            <p v-html="item.text"></p>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Qa',
    data(){
        return {
            list:[]
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    created(){
        this._fetchQaList();
    },
    methods: {
        _fetchQaList(){
            Utils.$ajax({
                url: '/qa/list',
            }).done(res=>{
                if(res.code!=0){
                    this.$toast(res.msg);
                    return;
                }
                this.list = res.data;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        height: 100%;
        background: #fff;
        padding: 2em;
    }
    .item{
        color: #fff;
        border-bottom: 1px dashed #fff;
        padding: 0 0 rem(50);
        &:last-child{
            border-bottom: none;
        }
        h2{
            font-size: rem(32);
            margin-bottom: rem(30);
        }
        img{
            width: 90%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Qa.vue